/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Measurement_NoteInputs */

const en_seo_measurement_note = /** @type {(inputs: Seo_Measurement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are AnyAPI's own measurements of traffic through the gateway, recomputed continuously, not a published service-level target.`)
};

const zh_hans1_seo_measurement_note = /** @type {(inputs: Seo_Measurement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些是 AnyAPI 对经过网关的流量的自有测量，持续重新计算，并非公开承诺的服务等级目标。`)
};

const pt_br2_seo_measurement_note = /** @type {(inputs: Seo_Measurement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estas são medições da própria AnyAPI sobre o tráfego que passa pelo gateway, recalculadas continuamente, e não uma meta de nível de serviço publicada.`)
};

const es_seo_measurement_note = /** @type {(inputs: Seo_Measurement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estas son mediciones propias de AnyAPI sobre el tráfico que pasa por el gateway, recalculadas continuamente, no un objetivo de nivel de servicio publicado.`)
};

const fr_seo_measurement_note = /** @type {(inputs: Seo_Measurement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce sont les propres mesures d’AnyAPI du trafic passant par la passerelle, recalculées en continu, et non un objectif de niveau de service publié.`)
};

const de_seo_measurement_note = /** @type {(inputs: Seo_Measurement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das sind AnyAPIs eigene Messungen des Traffics durch das Gateway, laufend neu berechnet, kein veröffentlichtes Service-Level-Ziel.`)
};

const ru_seo_measurement_note = /** @type {(inputs: Seo_Measurement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это собственные измерения AnyAPI по трафику через шлюз, пересчитываемые непрерывно, а не опубликованный целевой уровень обслуживания.`)
};

const it_seo_measurement_note = /** @type {(inputs: Seo_Measurement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono misurazioni di AnyAPI sul traffico che passa dal gateway, ricalcolate di continuo, non un obiettivo di livello di servizio pubblicato.`)
};

/**
* | output |
* | --- |
* | "These are AnyAPI's own measurements of traffic through the gateway, recomputed continuously, not a published service-level target." |
*
* @param {Seo_Measurement_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_measurement_note = /** @type {((inputs?: Seo_Measurement_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Measurement_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_measurement_note(inputs)
	if (locale === "pt-BR") return pt_br2_seo_measurement_note(inputs)
	if (locale === "es") return es_seo_measurement_note(inputs)
	if (locale === "fr") return fr_seo_measurement_note(inputs)
	if (locale === "de") return de_seo_measurement_note(inputs)
	if (locale === "ru") return ru_seo_measurement_note(inputs)
	if (locale === "it") return it_seo_measurement_note(inputs)
	return en_seo_measurement_note(inputs)
});